class Favorites {
  constructor(data) {
    this.entity = data || {};
  }

  get daysConsidered() {
    return this.entity.days_considered;
  }

  get value() {
    return this.entity.value || 0;
  }

  toJSON() {
    return {
      daysConsidered: this.daysConsidered,
      value: this.value,
    };
  }
}

export default Favorites;
